import { UserNetworkLeader } from '@ms/yammer-data/dist/state/types';

export const leaderSettingsPage = '/user-settings/leaders';
export const leaderSettingsAddLeadersPage = '/user-settings/leaders/addleaders';
export const leaderSettingsManageLeaderPage = '/user-settings/leaders/manage/:userId';

type LeaderSettingsManageLeaderPageWithLeaderId = (leaderId: UserNetworkLeader['id']) => string;
export const leaderSettingsManageLeaderPageWithLeaderId: LeaderSettingsManageLeaderPageWithLeaderId = (leaderId) =>
  leaderSettingsManageLeaderPage.replace(':userId', leaderId);
